export * from './locale-url-pathname'
